import { useAutoUpdatingRef } from '@quickmd-llc/frontend-utils'
import moment from 'moment'
import { type MutableRefObject, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setIsVideoDeclined } from 'store/waitingRoom/WaitingRoomActions'
import { type PatientWithVisitInfo } from 'types/types'
import { sendCustomSentryMessage } from 'utils/sentryUtility'

type Input = {
  showPatientDisconnected: boolean
  providerProfile?: {
    ProviderId: string
  }
  patientWithVisitInfo?: PatientWithVisitInfo
  endVideoId: MutableRefObject<string>
  endCallId: MutableRefObject<string>
  setShowPatientDisconnected: StateSetter<boolean>
  setShowConnecting: StateSetter<boolean>
  setIsCallAnswered: StateSetter<boolean>
}

export enum VisitCustomEvent {
  VISIT_VIDEO_DECLINED = 'VISIT_VIDEO_DECLINED',
  VISIT_CALL_DECLINED = 'VISIT_CALL_DECLINED',
  VISIT_CALL_ANSWERED = 'VISIT_CALL_ANSWERED',
}
export enum VisitMqttEvent {
  VISIT_VIDEO_DECLINED = 'visitvideodeclined',
  VISIT_CALL_DECLINED = 'visitphonedeclined',
  VISIT_CALL_ANSWERED = 'visitphoneanswered',
}

export function useHandleVisitMqttEvents(input: Input) {
  const listenerDataRef = useAutoUpdatingRef(input)

  const dispatch = useDispatch()

  useEffect(() => {
    const {
      showPatientDisconnected,
      providerProfile,
      patientWithVisitInfo,
      endVideoId,
      endCallId,
      setShowPatientDisconnected,
      setShowConnecting,
      setIsCallAnswered,
    } = listenerDataRef.current

    const handleVideoDeclined = (e: CustomEvent<{ VisitVideoCallId: string }>) => {
      const payload = e.detail
      sendCustomSentryMessage(
        `Received patient declined at ${moment().toISOString()} for provider ${providerProfile?.ProviderId} and visit ${patientWithVisitInfo?.VisitId}`,
      )
      dispatch(setIsVideoDeclined(true))
      endVideoId.current = payload.VisitVideoCallId
      setShowPatientDisconnected(true)
    }
    const handleCallDeclined = (e: CustomEvent<{ VisitId: string }>) => {
      const payload = e.detail
      setShowPatientDisconnected(true)
      endCallId.current = payload.VisitId
    }
    const handleCallAnswered = () => {
      if (!showPatientDisconnected) setIsCallAnswered(true)
      setShowConnecting(false)
    }

    // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
    document.addEventListener(VisitCustomEvent.VISIT_VIDEO_DECLINED, handleVideoDeclined)
    // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
    document.addEventListener(VisitCustomEvent.VISIT_CALL_DECLINED, handleCallDeclined)
    document.addEventListener(VisitCustomEvent.VISIT_CALL_ANSWERED, handleCallAnswered)

    return () => {
      // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
      document.removeEventListener(VisitCustomEvent.VISIT_VIDEO_DECLINED, handleVideoDeclined)
      // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
      document.removeEventListener(VisitCustomEvent.VISIT_CALL_DECLINED, handleCallDeclined)
      document.removeEventListener(VisitCustomEvent.VISIT_CALL_ANSWERED, handleCallAnswered)
    }
  }, [dispatch, listenerDataRef])
}
